export default __webpack_public_path__ + "static/media/Industrial.eecf1f56.jpg";